<template>
    <div>
        <a class="deco-none" data-toggle="collapse" :href="`#${id}`" aria-expanded="false" :aria-controls="`#${id}`" v-if="type==='link'">
            {{ label }}
            <i :class="iconClass" v-if="iconClass!==null"></i>
        </a>
        <button class="btn btn-primary" type="button" data-toggle="collapse" :data-target="`#${id}`" aria-expanded="false" :aria-controls="`#${id}`" v-else>
            {{ label }}
            <i :class="iconClass" v-if="iconClass!==null"></i>
        </button>
    </div>
</template>

<script>
export default {
    /**
        tag
        name: ks-collapse-button
        description: collapse button field component 
    **/
    name: "ks-collapse-button",
    props:{
        /**
            attribute
            name: id 
            description: id
        **/
        id:{
            type: String,
            required: true
        },
        /**
            attribute
            name: type 
            description: type
        **/
        type:{
            type:String,
            default: 'button'
        },
        /**
            attribute
            name: iconClass 
            description: iconClass
        **/
        iconClass: {
            type: String,
            default: null
        },
        /**
            attribute
            name: label 
            description: label
        **/
        label: {
            type: String,
            default: null
        }
    },

}
</script>

<style>
    .deco-none:link {
        color: inherit;
        text-decoration: inherit;
    }
</style>